import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'

interface AppBarProps extends MuiAppBarProps {
   open?: boolean
}

export const StyledFooter = styled(Box, {
   shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
   backgroundColor: theme.palette.primary.main,
   marginLeft: theme.sizes.closedSidebarWidth,
   width: `calc(100% - ${theme.sizes.closedSidebarWidth}px)`,
   ...(open && {
      marginLeft: theme.sizes.sidebarWidth,
      width: `calc(100% - ${theme.sizes.sidebarWidth}px)`,
   }),
   [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
      width: '100%',
   },
}))

export const StyledLogo = styled('img')(({ theme }) => ({
   maxHeight: theme.sizes.headerSm,
   maxWidth: 150,
   [theme.breakpoints.up('lg')]: {
      maxWidth: 210,
   },
   cursor: 'pointer',
}))

export const LinksContainer = styled('div')({
   color: '#cfd0d4',
})

export const StyledContactLink = styled('a')(({ theme }) => ({
   textDecoration: 'none',
   color: '#cfd0d4',
   fontWeight: 'bold',
   '&:hover': {
      color: theme.palette.primary.light,
   },
}))
